<document-upload-desktop
  [id]="'isf-documents-' + isfId + '-' + index + (document.id ? '-' + document.id : '')"
  [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
  [attachmentTypeName]="'LABELS.ISF' | translate | uppercase"
  [uploadedDocument]="document"
  [canUploadDocuments]="isCanUploadDocuments"
  [canRemoveDocuments]="canRemoveDocuments"
  [isLoading]="isLoading"
  [isStripeLayout]="true"
  [isStretched]="true"
  (upload)="onUploadDocument($event)"
  (remove)="onRemoveDocument($event)"
  (stateUpdate)="onStateUpdate($event)"
></document-upload-desktop>
